import { useEffect } from 'react';

export const usePartitionsStatusData = getPartitionsStatusRequest => {
    useEffect(() => {
        const timer = setInterval(() => getPartitionsStatusRequest(), 5.4e6);

        return () => clearInterval(timer);
    }, []);
};
